import { Database, Warning, CheckCircle } from '@phosphor-icons/react';

export default function SetupRequired() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4" data-testid="setup-required-page">
      <div className="max-w-3xl w-full">
        <div className="bg-white border border-zinc-200 p-8 shadow-sm">
          <div className="flex items-center gap-3 mb-2">
            <Warning size={32} weight="bold" className="text-red-600" />
            <h1 className="text-3xl font-black uppercase tracking-widest text-zinc-900" style={{ fontFamily: 'Chivo' }}>
              PENGATURAN DIPERLUKAN
            </h1>
          </div>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-8">
            KONFIGURASI SUPABASE UNTUK MULAI MENGGUNAKAN SISTEM
          </p>
          <div className="space-y-6">
            <div className="border-l-4 border-red-600 pl-4">
              <div className="flex items-center gap-2 mb-2">
                <Database size={16} weight="bold" className="text-zinc-900" />
                <p className="text-sm font-mono uppercase tracking-wider text-zinc-900 font-bold">LANGKAH 1 · BUAT PROYEK SUPABASE</p>
              </div>
              <p className="text-sm text-zinc-600 font-mono">
                Kunjungi <a href="https://supabase.com/dashboard" target="_blank" rel="noreferrer" className="text-red-600 hover:underline">supabase.com/dashboard</a> dan buat proyek baru.
              </p>
            </div>
            <div className="border-l-4 border-red-600 pl-4">
              <div className="flex items-center gap-2 mb-2">
                <Database size={16} weight="bold" className="text-zinc-900" />
                <p className="text-sm font-mono uppercase tracking-wider text-zinc-900 font-bold">LANGKAH 2 · JALANKAN SKRIP SQL</p>
              </div>
              <p className="text-sm text-zinc-600 font-mono mb-2">
                Buka <span className="text-zinc-900">SQL Editor</span> di dasbor Supabase, salin isi file:
              </p>
              <code className="block bg-zinc-50 border border-zinc-200 p-3 text-xs font-mono text-zinc-900">
                /app/supabase_setup.sql
              </code>
            </div>
            <div className="border-l-4 border-red-600 pl-4">
              <div className="flex items-center gap-2 mb-2">
                <CheckCircle size={16} weight="bold" className="text-zinc-900" />
                <p className="text-sm font-mono uppercase tracking-wider text-zinc-900 font-bold">LANGKAH 3 · TAMBAHKAN KREDENSIAL</p>
              </div>
              <code className="block bg-zinc-50 border border-zinc-200 p-3 text-xs font-mono text-zinc-900 whitespace-pre">
{`REACT_APP_SUPABASE_URL=https://your-project.supabase.co
REACT_APP_SUPABASE_ANON_KEY=your-publishable-key`}
              </code>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
